import { render, staticRenderFns } from "./PrequoteProduct.vue?vue&type=template&id=67388696&scoped=true&"
import script from "./PrequoteProduct.vue?vue&type=script&lang=js&"
export * from "./PrequoteProduct.vue?vue&type=script&lang=js&"
import style0 from "./PrequoteProduct.vue?vue&type=style&index=0&id=67388696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67388696",
  null
  
)

export default component.exports